const SocketActions = {
  MESSAGE: "message",
  TYPING: "typing",
  ONLINE_USER: "onlineUser",
};

export default SocketActions;
